import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', () => {
  const userCity = ref('');
  function setCity(city: string) {
    userCity.value = city;
  }
  return {
    userCity,
    setCity,
  };
});
